// @flow
// $FlowFixMe
import React, { Fragment } from 'react';
import styled, { keyframes, css } from 'styled-components';
import { Link } from 'react-router-dom';
import { X } from '@finect/tabular-icons/x';
import { maxMediaQueries } from '@finect/tabular-utils/mediaQueries';
import { disableBodyScroll, enableBodyScroll } from '@finect/tabular-utils/bodyScrollLock';
import { Button } from '@finect/tabular-core/Button';

const show = keyframes`
  0% {
    opacity: 0;
  }

  100% {
    opacity: 1;
  }
`;

const animation = css`
  animation: ${show} 0.2s ease;
`;

const OverBkg = styled.div`
  position: fixed;
  z-index: 300;

  height: 100%;
  width: 100%;
  bottom: 0;
  background: linear-gradient(to top, #fff, rgba(255, 255, 255, 0.2));

  ${animation};

  ${maxMediaQueries.phone`
    background: linear-gradient(to top, #fff, rgba(255, 255, 255, 0.5));
  `}
`;

const CloseOverlay = styled.div`
  position: absolute;
  z-index: 300;
  top: 20px;
  right: 20px;
  cursor: pointer;
  color: white;

  ${maxMediaQueries.phone`
    top: 15px;
    right: 15px;
  `};
`;

const ContentBox = styled.div`
  position: fixed;
  z-index: 300;

  height: 200px;
  min-width: 300px;
  width: 80%;
  max-width: 800px;
  bottom: 40%;
  left: 50%;
  transform: translateX(-50%);

  border-radius: 12px;
  background: ${({ theme }) => theme.plus.background};
  color: #fff;
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-items: center;
  font-size: 16px;
  font-weight: 400;

  padding: 24px 16px 0;
  ${animation};

  p {
    width: 100%;
  }

  ${Button} {
    width: 100%;
    max-width: 300px;
    border-radius: 8px;
    padding-top: 6px;
    padding-bottom: 6px;
    margin-top: 24px;
  }

  ${maxMediaQueries.phone`
    height: auto;
    width: 90%;
    padding: 36px 14px 14px;
    
    ${Button} {
     max-width: 100%;
    }
  `}
`;

const TYPES_WITH_BLOCKED_SCREEN = ['comparison', 'comparison-daily'];

const TEXT_TYPES = {
  product: 'productos favoritos',
  article: 'artículos favoritos',
  comparison: 'comparaciones guardadas',
  'comparison-daily': 'comparaciones diarias'
};

const EXTRA_BY_TYPE = {
  product: 'guardar productos ilimitados',
  article: 'guardar artículos ilimitados',
  comparison: 'guardar comparaciones ilimitadas',
  'comparison-daily': 'hacer comparaciones ilimitadas'
};

const TEXT_PERIODS = {
  month: 'mensual'
};

type Props = {
  url: string,
  data: Object,
  closePlusOverlay: Function
};

export class PlusOverBox extends React.Component<Props> {
  target: HTMLElement | null;

  componentDidMount() {
    if (TYPES_WITH_BLOCKED_SCREEN.includes(this.props.data.type)) {
      disableBodyScroll(this.target);
    }
  }

  componentWillUnmount() {
    if (TYPES_WITH_BLOCKED_SCREEN.includes(this.props.data.type)) {
      enableBodyScroll(this.target);
    }
  }

  render() {
    const { url, data, closePlusOverlay } = this.props;

    // param back to current url
    const urlWithBack = `${url}?back=${encodeURIComponent(window.location.href)}`;

    const period = TEXT_PERIODS[data.period];
    const extra = EXTRA_BY_TYPE[data.type];

    return (
      <Fragment>
        <OverBkg ref={el => (this.target = el)} onClick={closePlusOverlay} />
        <ContentBox>
          <p style={{ marginBottom: 16 }}>
            ¡Vaya! Has alcanzado tu límite {period ? `${period} ` : ''}de {TEXT_TYPES[data.type]}.
          </p>
          <p>
            ✅ Actualiza a <b>Finect Plus</b> para {extra ? `${extra} y ` : ''}acceder a {extra ? `otros ` : ''}
            servicios exclusivos.
          </p>

          <Button as={Link} to={urlWithBack} secondary={true} onClick={closePlusOverlay}>
            Más sobre <b>Finect Plus</b>
          </Button>

          <CloseOverlay onClick={closePlusOverlay}>
            <X />
          </CloseOverlay>
        </ContentBox>
      </Fragment>
    );
  }
}
